module.exports = __webpack_public_path__ + "img/1545293233.29b32214.jpg";